export default __webpack_public_path__ + "static/media/makita_HM1203C.bf6818e4.jpg";